export default {
  children: [
    {
      path: '/HTIndex',
      name: 'HTIndex',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('../plugins/backer/layout/HTIndex.vue')
    },
    //功能模块
    //项目合作管理
    {
      path: '/Xmhzgl',
      name: 'Xmhzgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Xmhzgl.vue')
    },
    {
      path: '/XmhzUpdate',
      name: 'XmhzUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/XmhzUpdate.vue')
    },
    //矿业资讯管理
    {
      path: '/Kyzxgl',
      name: 'Kyzxgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Kyzxgl.vue')
    },
    {
      path: '/KyzxUpdate',
      name: 'KyzxUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyzxUpdate.vue')
    },
    //矿业展会管理
    {
      path: '/Kyzhgl',
      name: 'Kyzhgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Kyzhgl.vue')
    },
    {
      path: '/KyzhUpdate',
      name: 'KyzhUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KyzhUpdate.vue')
    },
    //线上云展管理_云上展厅管理
    {
      path: '/Ysztgl',
      name: 'Ysztgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/xsyzgl/Ysztgl.vue')
    },
    //线上云展管理_会议发布管理
    {
      path: '/Hyfbgl',
      name: 'Hyfbgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
                import('@/plugins/backer/project/xsyzgl/Hyfbgl.vue')
    },
    {
      path: '/HyfbglUpdate',
      name: 'HyfbglUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
            import('@/plugins/backer/project/xsyzgl/HyfbglUpdate.vue')
    },
    //线上云展管理_企业展示管理
    {
      path: '/Qyzsgl',
      name: 'Qyzsgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
                import('@/plugins/backer/project/xsyzgl/Qyzsgl.vue')
    },
    {
      path: '/QyzsUpdate',
      name: 'QyzsUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
                import('@/plugins/backer/project/xsyzgl/QyzsUpdate.vue')
    },
    //东盟矿业管理
    {
      path: '/Dmkygl',
      name: 'Dmkygl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Dmkygl.vue')
    },
    {
      path: '/DmkyUpdate',
      name: 'DmkyUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/DmkyUpdate.vue')
    },
    //矿产品管理
    {
      path: '/Kcpgl',
      name: 'Kcpgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Kcpgl.vue')
    },
    {
      path: '/KcpUpdate',
      name: 'KcpUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KcpUpdate.vue')
    },
    //珠宝玉石管理
    {
      path: '/Zbysgl',
      name: 'Zbysgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Zbysgl.vue')
    },
    {
      path: '/ZbysUpdate',
      name: 'ZbysUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ZbysUpdate.vue')
    },
    //矿业设备管理
    {
      path: '/Kysbgl',
      name: 'Kysbgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Kysbgl.vue')
    },
    {
      path: '/KysbUpdate',
      name: 'KysbUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KysbUpdate.vue')
    },
    //矿用药剂管理
    {
      path: '/Kyyjgl',
      name: 'Kyyjgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project//Kyyjgl.vue')
    },
    {
      path: '/KyyjUpdate',
      name: 'KyyjUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project//KyyjUpdate.vue')
    },
    //数据共享管理
    {
      path: '/Sjgxgl',
      name: 'Sjgxgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Sjgxgl.vue')
    },
    {
      path: '/SjgxUpdate',
      name: 'SjgxUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/SjgxUpdate.vue')
    },
    //资料库管理
    {
      path: '/Dxzlgl',
      name: 'Dxzlgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Dxzlgl.vue')
    },
    {
      path: '/DxzlUpdate',
      name: 'DxzlUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/DxzlUpdate.vue')
    },
    //专家文章管理
    {
      path: '/Zjwzgl',
      name: 'Zjwzgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Zjwzgl.vue')
    },
    {
      path: '/ZjwzUpdate',
      name: 'ZjwzUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ZjwzUpdate.vue')
    },
    //媒体合作管理
    {
      path: '/Mthzgl',
      name: 'Mthzgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Mthzgl.vue')
    },
    {
      path: '/MthzUpdate',
      name: 'MthzUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/MthzUpdate.vue')
    },
    //企业展示资质列表管理
    {
      path: '/QyzsZzlbUpdata',
      name: 'QyzsZzlbUpdata',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/xsyzgl/QyzsZzlbUpdata.vue')
    },
    //企业展示产品列表管理
    {
      path: '/QyzsCplbUpdate',
      name: 'QyzsCplbUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/xsyzgl/QyzsCplbUpdate.vue')
    },
    {
      path: '/QyzsLook',
      name: 'QyzsLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/xsyzgl/QyzsLook.vue')
    },
    {
      path: '/ToExamine',
      name: 'ToExamine',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ToExamine.vue')
    },
    {
      path: '/TokyExamine',
      name: 'TokyExamine',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/TokyExamine.vue')
    },
    {
      path: '/ToqtExamine',
      name: 'ToqtExamine',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ToqtExamine.vue')
    },
    {
      path: '/DmkyLook',
      name: 'DmkyLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/DmkyLook.vue')
    },
    {
      path: '/HyfbLook',
      name: 'HyfbLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/xsyzgl/HyfbLook.vue')
    },
    {
      path: '/KyzxLook',
      name: 'KyzxLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KyzxLook.vue')
    },
    {
      path: '/XmhzLook',
      name: 'XmhzLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/XmhzLook.vue')
    },
    // 参会报名管理
    {
      path: '/Chbmgl',
      name: 'Chbmgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Chbmgl.vue')
    },
    {
      path: '/ChbmShow',
      name: 'ChbmShow',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ChbmShow.vue')
    },
    // 办会报名管理
    {
      path: '/Bhbmgl',
      name: 'Bhbmgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Bhbmgl.vue')
    },
    {
      path: '/BhbmShow',
      name: 'BhbmShow',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/BhbmShow.vue')
    },
    {
      path: '/KyzhLook',
      name: 'KyzhLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KyzhLook.vue')
    },
    {
      path: '/KcpLook',
      name: 'KcpLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KcpLook.vue')
    },
    {
      path: '/ZbysLook',
      name: 'ZbysLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ZbysLook.vue')
    },
    {
      path: '/KysbLook',
      name: 'KysbLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KysbLook.vue')
    },
    {
      path: '/KyyjLook',
      name: 'KyyjLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/KyyjLook.vue')
    },
    {
      path: '/Usergl',
      name: 'Usergl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Usergl.vue')
    },
    {
      path: '/Rolegl',
      name: 'Rolegl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Rolegl.vue')
    },
    //东盟地学管理
    {
      path: '/Dmdxgl',
      name: 'Dmdxgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Dmdxgl.vue')
    },
    {
      path: '/DmdxLook',
      name: 'DmdxLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/DmdxLook.vue')
    },
    {
      path: '/DmdxUpdate',
      name: 'DmdxUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/DmdxUpdate.vue')
    },
    {
      path: '/ToRelease',
      name: 'ToRelease',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ToRelease.vue')
    },
    {
      path: '/ToKyRelease',
      name: 'ToKyRelease',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ToKyRelease.vue')
    },
    {
      path: '/ToQtRelease',
      name: 'ToQtRelease',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ToQtRelease.vue')
    },
    {
      path: '/DxzlLook',
      name: 'DxzlLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/DxzlLook.vue')
    },
    {
      path: '/SjgxLook',
      name: 'SjgxLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/SjgxLook.vue')
    },
    {
      path: '/MthzLook',
      name: 'MthzLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/MthzLook.vue')
    },
    {
      path: '/ZjwzLook',
      name: 'ZjwzLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/ZjwzLook.vue')
    },
    {
      path: '/UserUpdate',
      name: 'UserUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/UserUpdate.vue')
    },
    {
      path: '/RoleUpdate',
      name: 'RoleUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/RoleUpdate.vue')
    },

    //东盟各国投资书册管理
    {
      path: '/Dmtzgl',
      name: 'Dmtzgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/Dmtzgl.vue')
    },
    {
      path: '/DmtzLook',
      name: 'DmtzLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
        import('@/plugins/backer/project/DmtzLook.vue')
    },
    {
      path: '/DmtzUpdate',
      name: 'DmtzUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/DmtzUpdate.vue')
    },
    {
      path: '/Membergl',
      name: 'Membergl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Membergl.vue')
    },
    {
      path: '/MemberUpdate',
      name: 'MemberUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/MemberUpdate.vue')
    },
    {
      path: '/KyxxMap',
      name: 'KyxxMap',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyxxMap.vue')
    },
    {
      path: '/KyxxUpdate',
      name: 'KyxxUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyxxUpdate.vue')
    },
    {
      path: '/FirInfo',
      name: 'FirInfo',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/FirInfo.vue')
    },
    {
      path: '/MineUpdate',
      name: 'MineUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/MineUpdate.vue')
    },
    {
      path: '/Sjcjgl',
      name: 'Sjcjgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Sjcjgl.vue')
    },
    {
      path: '/SjcjUpdate',
      name: 'SjcjUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/SjcjUpdate.vue')
    },
    {
      path: '/KyltMgl',
      name: 'KyltMgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyltMgl.vue')
    },
    {
      path: '/KyltMUpdate',
      name: 'KyltMUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyltMUpdate.vue')
    },
    {
      path: '/RcepColumngl',
      name: 'RcepColumngl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/RcepColumngl.vue')
    },
    {
      path: '/RcepUpdate',
      name: 'RcepUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/RcepUpdate.vue')
    },
    {
      path: '/FirBannerUpdate',
      name: 'FirBannerUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/FirBannerUpdate.vue')
    },
    {
      path: '/Processgl',
      name: 'Processgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Processgl.vue')
    },
    {
      path: '/ProcessUpdate',
      name: 'ProcessUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/ProcessUpdate.vue')
    },
    {
      path: '/KyltPdfUpdate',
      name: 'KyltPdfUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyltPdfUpdate.vue')
    },
    {
      path: '/KyltTitleUpdate',
      name: 'KyltTitleUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyltTitleUpdate.vue')
    },
    {
      path: '/FirScienceUpdate',
      name: 'FirScienceUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/FirScienceUpdate.vue')
    },
    {
      path: '/Gywmgl',
      name: 'Gywmgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Gywmgl.vue')
    },
    {
      path: '/GywmUpdate',
      name: 'GywmUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/GywmUpdate.vue')
    },
    {
      path: '/YqjbUpdate',
      name: 'YqjbUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/YqjbUpdate.vue')
    },
    {
      path: '/SponsorUpdate',
      name: 'SponsorUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/SponsorUpdate.vue')
    },
    {
      path: '/Kyzhzxgl',
      name: 'Kyzhzxgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Kyzhzxgl.vue')
    },
    {
      path: '/KyzhzxUpdate',
      name: 'KyzhzxUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyzhzxUpdate.vue')
    },
    {
      path: '/FirPhotoUpdate',
      name: 'FirPhotoUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/FirPhotoUpdate.vue')
    },
    {
      path: '/FirRollUpdate',
      name: 'FirRollUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/FirRollUpdate.vue')
    },
    {
      path: '/Fkjjygl',
      name: 'Fkjjygl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Fkjjygl.vue')
    },
    {
      path: '/Kyzxfwgl',
      name: 'Kyzxfwgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Kyzxfwgl.vue')
    },
    {
      path: '/Flfwgl',
      name: 'Flfwgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Flfwgl.vue')
    },
    {
      path: '/KyzxfwUpdate',
      name: 'KyzxfwUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KyzxfwUpdate.vue')
    },
    {
      path: '/Hyzjgl',
      name: 'Hyzjgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Hyzjgl.vue')
    },
    {
      path: '/HyzjUpdate',
      name: 'HyzjUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/HyzjUpdate.vue')
    },
    {
      path: '/HyzjLook',
      name: 'HyzjLook',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/HyzjLook.vue')
    },
    {
      path: '/Organisegl',
      name: 'Organisegl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Organisegl.vue')
    },
    {
      path: '/OrganiseUpdate',
      name: 'OrganiseUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/OrganiseUpdate.vue')
    },
    {
      path: '/LoginLog',
      name: 'LoginLog',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/LoginLog.vue')
    },
    {
      path: '/OperLog',
      name: 'OperLog',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/OperLog.vue')
    },
    {
      path: '/Kqtjgl',
      name: 'Kqtjgl',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/Kqtjgl.vue')
    },
    {
      path: '/KqtjUpdate',
      name: 'KqtjUpdate',
      meta: {
        title: '后台管理系统',
        requireAuth: true
      },
      component: () =>
          import('@/plugins/backer/project/KqtjUpdate.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/children.js